// extracted by mini-css-extract-plugin
module.exports = {"container":"IntroCopy_container__4glWV","header":"IntroCopy_header__uibbI","copy":"IntroCopy_copy__PCbG8"};